import React, { FC } from 'react';
import { FacebookIcon, FooterLogo, YouTubeIcon } from '../SvgIcon';
import { useLocation } from '@reach/router';
interface FooterProps {
  title: string;
  subtitle: string;
}

const Footer: FC<FooterProps> = ({ title, subtitle }) => {
  const location = useLocation();
  if (location.pathname.includes('webapp')) return <></>;
  return (
    <footer className="bg-base-100 py-8">
      <div className="flex flex-row mx-5 md:mx-10 lg:mx-20 xl:mx-auto max-w-6xl justify-between">
        <aside className="block">
          <div className="flex items-center">
            <FooterLogo />
            <div className="grid grid-cols-1 place-content-start ml-4">
              <div className=" text-2xl font-black text-primary">{title}</div>
              <div className="text-accent">{subtitle}</div>
            </div>
          </div>
        </aside>
        <div>
          <div className="footer-title text-secondary">Social</div>
          <div className="grid grid-flow-col gap-2 text-primary">
            <a>
              <YouTubeIcon height={5} width={5} />
            </a>
            <a>
              <FacebookIcon height={5} width={5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
